import React from "react";
import { LogIn, MessageCircle, X } from "lucide-react";
import { google } from "@/components/public/Shop";

export const GUEST_MAX_MB = 10;

export const LoginGate = ({ reason, phone, close }) => {
  const wa = (phone || "").replace(/\D/g, "").replace(/^0/, "62");
  const msg = encodeURIComponent("Halo FOMU, saya mau konsultasi / kirim file 3D untuk dihitung harganya.");
  return (
    <div className="fixed inset-0 z-[80] bg-black/50 grid place-items-center p-4" onClick={close} data-testid="calc-login-gate">
      <div className="bg-white rounded-3xl max-w-sm w-full p-6 relative" onClick={(e) => e.stopPropagation()}>
        <button type="button" onClick={close} data-testid="calc-gate-close" className="absolute top-4 right-4 text-slate-400 hover:text-slate-700"><X className="w-5 h-5" /></button>
        <h3 className="text-xl font-bold pr-6">Log in untuk lanjut</h3>
        <p className="text-sm text-slate-500 mt-1" data-testid="calc-gate-reason">{reason}</p>
        <ul className="text-xs text-slate-500 mt-3 list-disc pl-4 space-y-0.5">
          <li>Tanpa log in: simulasi harga file sampai {GUEST_MAX_MB} MB.</li>
          <li>Setelah log in: file sampai 100 MB, maksimal 10 file, kirim quotation & PDF.</li>
        </ul>
        <button type="button" data-testid="calc-gate-login" onClick={() => google("/calculator")} className="mt-5 w-full py-3 rounded-full bg-slate-900 text-white font-semibold inline-flex justify-center items-center gap-2 hover:bg-slate-700 transition-colors"><LogIn className="w-4 h-4" /> Log in dengan Google</button>
        {wa && <a href={`https://wa.me/${wa}?text=${msg}`} target="_blank" rel="noreferrer" data-testid="calc-gate-wa" className="mt-2 w-full py-3 rounded-full border border-emerald-500 text-emerald-700 font-semibold inline-flex justify-center items-center gap-2 hover:bg-emerald-50 transition-colors"><MessageCircle className="w-4 h-4" /> Kontak tim FOMU via WA</a>}
      </div>
    </div>
  );
};
